import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetFrameCommentIdsOnMarkersMutationVariables = Types.Exact<{
  input: Types.SetFrameCommentIdsOnMarkersInput;
}>;


export type SetFrameCommentIdsOnMarkersMutation = { __typename?: 'Mutation', setFrameCommentIdsOnMarkers?: boolean | null };


export const SetFrameCommentIdsOnMarkers = /*#__PURE__*/ gql`
    mutation SetFrameCommentIdsOnMarkers($input: SetFrameCommentIdsOnMarkersInput!) {
  setFrameCommentIdsOnMarkers(input: $input)
}
    ` as unknown as DocumentNode<SetFrameCommentIdsOnMarkersMutation, SetFrameCommentIdsOnMarkersMutationVariables>;

          

          export const useSetFrameCommentIdsOnMarkersMutation = (options?:MutationHookOptions<SetFrameCommentIdsOnMarkersMutation, SetFrameCommentIdsOnMarkersMutationVariables>) => useMutation(SetFrameCommentIdsOnMarkers, options);
          

          export type SetFrameCommentIdsOnMarkersMutationOptions = MutationHookOptions<SetFrameCommentIdsOnMarkersMutation, SetFrameCommentIdsOnMarkersMutationVariables>;

          

          export type SetFrameCommentIdsOnMarkersMutationResult = ReturnType<typeof useSetFrameCommentIdsOnMarkersMutation>[1];

          
